export default "__VITE_ASSET__b62fef01__"